import * as React from "react";

export const Erro = ({ error, touched }) => {
    if (error && touched) {
        return <div className="text-danger font-quicksand--medium" style={{ height: 0 }}>{error}</div>;
    }
    return <div />;
};
